<template>
  <div>
    <h3 class="primary">
      {{this.processName}}
      <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="handleCancel()"
          >{{$t('processReview.back')}}</el-button
        >
    </h3>
    

    <el-card class="box-card" shadow="never" v-for="node in itemList" :key="node.id" style="margin-bottom: 25px;">
      <div style="display:flex;align-items: center;">
        <el-avatar style="background-color: blue;" v-if="node.type == 1">{{$t('processReview.auto')}} </el-avatar>
        <el-avatar style="background-color: darkmagenta;" v-if="node.type == 2">{{$t('processReview.manual')}}</el-avatar>
        <span style="line-height: 30px;font-size: 14px; margin-left: 5px">{{node.name}}</span>
      </div>
      <div style="color: #999;margin: 0px 0px 5px 45px">{{node.comment}}</div>

      <el-collapse v-model="activeNames" >
        <el-collapse-item :title="$t('processReview.command')" name="c">
          <template>
            <div v-for="cmd in node.commandList" :key="cmd.id">
              <i class="el-icon-bottom" style="color: rgb(22, 161, 22);"></i>&nbsp;{{cmd.command}}&nbsp;{{cmd.label}}
            </div>
          </template>
        </el-collapse-item>
        <el-collapse-item :title="$t('processReview.resource')" name="r">
          <template>
            <div v-for="data in node.resourceList" :key="data.id">
              <i class="el-icon-folder" v-if="data.type == 0"></i>&nbsp;
              <i class="el-icon-coin" v-if="data.type == 1"></i>&nbsp;
              <i class="el-icon-box" v-if="data.type == 9"></i>&nbsp;
              {{data.name}}&nbsp;{{data.value}}
            </div>
          </template>
          
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template>

<script>
import { listNode} from "@/api/process";
export default {
  props: {
    processID: String,
    processName: String,
    handleCancel: Function
  },
  name: "ProcessReview",
  data() {
    return {
      itemList: [],
      activeNames: []
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      listNode({
        processID: this.processID,
      }).then((response) => {
        this.itemList = response.data.items;
      });
    },
    // handleChange(val) {
      
    // }
  }
};
</script>
